export default "__VITE_ASSET__BBgLmScP__"